import { ref as i, provide as r, inject as t } from "vue";
const n = Symbol(), s = (o) => {
  const e = t(n, void 0);
  e && (e.value = o);
}, c = () => {
  const o = i();
  return r(n, o), {
    /** The region heading id ref */
    id: o
  };
};
export {
  n as CARD_Heading_SYMBOL,
  s as useCardHeading,
  c as useCardRegion
};
